import React, { Component } from "react";
import { DataTable, CurrencyValue } from "components/support";

class MultilocalitySalesReportDataTable extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "company_name",
        align: "left",
        Header: "Nome da Empresa"
      },
      {
        accessor: "sales_quantity",
        align: "right",
        Header: "Quantidade de Vendas"
      },
      {
        id: "quantity_per_sale",
        accessor: ({ quantity_per_sale }) => (
          <CurrencyValue value={quantity_per_sale} />
        ),
        align: "center",
        Header: "Média de Produtos por Venda"
      },
      {
        id: "service_total",
        accessor: ({ service_total }) => service_total,
        Header: "Total de Taxa de Serviço",
        type: "money",
        align: "center"
      },
      {
        id: "discount",
        accessor: ({ discount }) => discount,
        Header: "Total de Desconto",
        type: "money",
        align: "right"
      },
      {
        id: "ticket",
        accessor: ({ ticket }) => ticket,
        Header: "Ticket Médio",
        type: "money",
        align: "right"
      },
      {
        id: "revenues_value",
        accessor: ({ revenues_value }) => revenues_value,
        Header: "Faturamento",
        type: "money",
        align: "right"
      }
    ]
  };

  render() {
    const { results, pagination, order } = this.props;

    return (
      <DataTable
        manual
        defaultSorted={[
          {
            id: order.field,
            desc: order.direction === "DESC"
          }
        ]}
        filterable={false}
        resultSet={results}
        total={pagination.total}
        perPage={pagination.perPage}
        page={pagination.page}
        config={this.config}
        onChange={({ field, value }) => this.props.onOrderChange(field, value)}
        orderField={order.field}
        orderDirection={order.direction}
        onPageChange={page => this.props.onPageChange(page + 1)}
      />
    );
  }
}

export default MultilocalitySalesReportDataTable;



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/data-table/index.js